import ImagePart from "./ImagePart";
import PartParam from "./PartParam";
import LocalStorageService from "../../service/LocalStorageService";
import { Button, PopoverBody } from "reactstrap";
import Popover from "reactstrap/lib/Popover";
import * as React from "react";
import { Component } from "react";
import { LabelPartParam } from "../../api/LabelizeApi";
import CancelableAxiosInstance from "../../api/CancelableAxiosInstance";
import GlmId from "../../component/GlmId";
import { AuthManager } from "../../component/auth/AuthContext";
import i18n from "i18next";

interface LabelPartParamItemProps {
  client: CancelableAxiosInstance;
  partParam: LabelPartParam;

  onValueChange(partParam: LabelPartParam): void;

  prefValues: string[];
  index: number;
  authManager: AuthManager;
}

interface LabelPartParamItemState {
  showInfo: boolean;
}

export default class LabelPartParamItem extends Component<LabelPartParamItemProps, LabelPartParamItemState> {
  private manualPopOver = false;

  constructor(props: LabelPartParamItemProps) {
    super(props);
    this.state = {
      showInfo: false,
    };
  }

  private setImageState(imageState: string) {
    this.props.partParam.imageState = imageState;
  }

  private renderImageStateButton() {
    if (this.props.partParam.imageState === "doubt") {
      return (
        <button
          title={i18n.t("labelize.correctRegion")}
          className="btn btn-outline-danger"
          onClick={() => this.setImageState("validated")}
        >
          <i className="fa fa-scissors" />
        </button>
      );
    } else if (this.props.partParam.imageState === "validated") {
      return (
        <button
          className="btn btn-outline-success"
          title={i18n.t("labelize.incorrectRegion")}
          onClick={() => this.setImageState("doubt")}
        >
          <i className="fa fa-scissors" />
        </button>
      );
    }
  }

  render() {
    return (
      <div>
        <Button
          color="secondary"
          size="sm"
          outline
          className="vp-top-right m-1"
          title={i18n.t("labelize.displayedInfo")}
          id={"pop" + this.props.index}
          type="button"
          onClick={() => this.toggleManualPopOver()}
          onMouseEnter={() => this.openPopOver()}
          onMouseLeave={() => this.closePopOver()}
        >
          <i className="fa fa-info-circle" />
        </Button>

        <ImagePart client={this.props.client} imagePart={this.props.partParam} authManager={this.props.authManager} />

        <div className="row col-auto mt-1">
          <div className="d-inline">{this.renderImageStateButton()}</div>
          <div className="d-inline">
            <PartParam
              partParam={this.props.partParam}
              partParamType={LocalStorageService.getPartParamType(this.props.partParam.type)}
              onValueChange={(pp) => this.props.onValueChange(pp)}
              prefValues={this.props.prefValues}
            />
            <Popover
              placement="bottom"
              isOpen={this.state.showInfo}
              target={"pop" + this.props.index}
              toggle={() => this.togglePopOver()}
            >
              <PopoverBody>
                <div>
                  GlmStudyId : <GlmId value={this.props.partParam.studyId} />
                </div>
                <div>
                  Ai value : {this.props.partParam.aiValue} / Ai Confidence : {this.props.partParam.aiConfidence}
                </div>
              </PopoverBody>
            </Popover>
          </div>
        </div>
      </div>
    );
  }

  private toggleManualPopOver() {
    this.manualPopOver = !this.manualPopOver;
    this.setState({ showInfo: this.manualPopOver });
  }

  private togglePopOver() {
    this.setState({ showInfo: !this.state.showInfo });
  }

  private openPopOver() {
    if (!this.manualPopOver) {
      this.setState({ showInfo: true });
    }
  }

  private closePopOver() {
    if (!this.manualPopOver) {
      this.setState({ showInfo: false });
    }
  }
}
